import styled from 'styled-components'

export const SubPagesWrapper = styled.div<{ $isMobile: boolean }>`
  display: grid;
  grid-template-columns: repeat(6, minmax(50px, 250px));
  grid-gap: 24px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
    grid-template-columns: repeat(1, minmax(50px, 600px));
    justify-content: center;
  `}
`

export const SubPageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 380px;
  padding: 16px 24px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start !important;
  gap: 12px !important;

  border: 3px solid #90258c;
`

export const StyledImg = styled.img`
  width: 100%;
  height: auto;
`

export const StyledTitle = styled.h3`
  align-self: flex-start;

  font-size: 16px;
  font-weight: 800;
`

export const StyledDescription = styled.p`
  align-self: flex-start;
`

export const StyledButton = styled.a<{ $isMobile: boolean }>`
  position: absolute;
  bottom: 16px;
  left: 24px;

  color: #fff;
  background-color: #90258c;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 0;

  ${({ $isMobile }) =>
    $isMobile &&
    `
    left: unset;
    padding: 12px 24px;
    font-size: 16px;
  `}
`
